module.exports = __webpack_public_path__ + "img/bgLeft.6d057741.png";